import { InAppMessageView } from "./view/InAppMessageView"
import { InAppMessageViewEventHandleProcessor } from "./event/InAppMessageViewEventHandleProcessor"
import { InAppMessageInteractionHandlerFactory } from "./event/InAppMessageInteractionHandler"
import { HackleInAppMessageListener } from "../../../public/model"
import { InAppMessagePresenter } from "../present/presentation/InAppMessagePresenter"
import { InAppMessagePresentationContext } from "../present/presentation/InAppMessagePresentationContext"
import ObjectUtil from "../../../core/internal/util/ObjectUtil"
import { InAppMessageViewFactories } from "./view/factory/InAppMessageViewFactories"
import { Clock } from "../../../core/internal/util/TimeUtil"
import { InAppMessagePresentResponse } from "../present/InAppMessagePresentResponse"

export class InAppMessageUi implements InAppMessagePresenter {
  public currentMessageView: InAppMessageView | null = null
  private opening: boolean = false

  constructor(
    private readonly viewFactories: InAppMessageViewFactories,
    public readonly viewEventHandleProcessor: InAppMessageViewEventHandleProcessor,
    public readonly interactionHandlerFactory: InAppMessageInteractionHandlerFactory,
    public readonly clock: Clock,
    public inAppMessageListener: HackleInAppMessageListener | null = null
  ) {}

  setListener(listener: HackleInAppMessageListener | null) {
    this.inAppMessageListener = listener
  }

  async present(context: InAppMessagePresentationContext): Promise<InAppMessagePresentResponse> {
    if (this.currentMessageView) {
      return InAppMessagePresentResponse.of("ALREADY_PRESENTED", context)
    }
    if (this.opening) {
      return InAppMessagePresentResponse.of("IN_PROGRESS", context)
    }

    this.opening = true

    let messageView: InAppMessageView | null = null
    try {
      const viewFactory = ObjectUtil.requiredNotNullOrUndefined(
        this.viewFactories.get(context),
        () =>
          `Unsupported InAppMessagePresentationContext[${context.message.layout.displayType}], Can't create message view`
      )

      messageView = viewFactory.create(context, this)
      if (messageView === null) {
        return InAppMessagePresentResponse.of("PRESENT", context)
      }

      this.currentMessageView = messageView
      await messageView.open()
      return InAppMessagePresentResponse.of("PRESENT", context)
    } catch (e) {
      messageView?.close()
      return InAppMessagePresentResponse.of("EXCEPTION", context)
    } finally {
      this.opening = false
    }
  }
}
